// countdown-section.js
class CountdownSection {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.timerElement = sectionElement.querySelector('.countdown-timer');
    this.endDate = this.timerElement.dataset.endDate;
    this.timezone = this.timerElement.dataset.timezone;
    this.countdownInterval = null;
    
    this.init();
  }
  
  init() {
    this.applyStyles();
    this.startCountdown();
  }
  
  applyStyles() {
    // Aplicar estilos desde las configuraciones
    const styles = {
      '--font-family': this.section.dataset.fontFamily || 'sans-serif',
      '--font-weight': this.section.dataset.fontBold === 'true' ? '700' : '400',
      '--number-spacing': `${this.section.dataset.numberSpacing || 0}px`,
      '--number-color': this.section.dataset.numberColor || '#000000',
      '--label-color': this.section.dataset.labelColor || '#666666',
      '--background-color': this.section.dataset.backgroundColor || '#ffffff',
      '--border-color': this.section.dataset.borderColor || '#e0e0e0'
    };
    
    Object.keys(styles).forEach(property => {
      this.section.style.setProperty(property, styles[property]);
    });
  }
  
  startCountdown() {
    this.updateCountdown();
    
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }
  
  updateCountdown() {
    const now = this.timezone === 'UTC' ? new Date().getTime() : new Date().getTime();
    const end = this.timezone === 'UTC' ? 
      new Date(this.endDate + 'Z').getTime() : 
      new Date(this.endDate).getTime();
    
    const timeLeft = end - now;
    
    if (timeLeft < 0) {
      this.handleCountdownEnd();
      return;
    }
    
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    
    this.updateDisplay(days, hours, minutes, seconds);
  }
  
  updateDisplay(days, hours, minutes, seconds) {
    const elements = {
      days: this.timerElement.querySelector('.days'),
      hours: this.timerElement.querySelector('.hours'),
      minutes: this.timerElement.querySelector('.minutes'),
      seconds: this.timerElement.querySelector('.seconds')
    };
    
    if (elements.days) elements.days.textContent = this.formatTime(days);
    if (elements.hours) elements.hours.textContent = this.formatTime(hours);
    if (elements.minutes) elements.minutes.textContent = this.formatTime(minutes);
    if (elements.seconds) elements.seconds.textContent = this.formatTime(seconds);
  }
  
  formatTime(time) {
    return time < 10 ? `0${time}` : time;
  }
  
  handleCountdownEnd() {
    clearInterval(this.countdownInterval);
    
    // Mostrar mensaje de finalizado
    const units = this.timerElement.querySelectorAll('.countdown-unit');
    units.forEach(unit => {
      unit.style.opacity = '0.5';
    });
    
    // Opcional: Mostrar mensaje
    const message = document.createElement('div');
    message.className = 'countdown-ended';
    message.textContent = 'Offer has ended!';
    message.style.cssText = `
      text-align: center;
      font-size: 1.5rem;
      font-weight: bold;
      color: #ff4444;
      margin-top: 20px;
    `;
    
    this.timerElement.appendChild(message);
  }
  
  destroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}

// Inicializar todas las secciones de countdown
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.countdown-section');
  sections.forEach(section => {
    new CountdownSection(section);
  });
});

// Para secciones dinámicas de Shopify
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function(e) {
    const section = e.target.querySelector('.countdown-section');
    if (section) {
      new CountdownSection(section);
    }
  });
  
  document.addEventListener('shopify:section:unload', function(e) {
    const section = e.target.querySelector('.countdown-section');
    if (section && section.countdownInstance) {
      section.countdownInstance.destroy();
    }
  });
}